import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EditIcon from '@material-ui/icons/Edit';
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import PropTypes from "prop-types";
import React, { Component } from "react";
import cookie from "react-cookies";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
  Switch
} from "react-router-dom";
import "./global.css";
import ContestListView from "./views/ContestListView";
import ContestView from "./views/ContestView";
import HomeView from "./views/HomeView";
import LoginView from "./views/LoginView";
import RankingView from "./views/RankingView";
import UserView from "./views/UserView";
import config from "./config";
import DraftView from "./views/DraftView";
import MyPageView from "./views/MyPageView";


const drawerWidth = 240;

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    // flexGrow: 1,
    padding: theme.spacing(3),
    maxWidth: "900px",
    width: "100%",
  },
  userIcon: {
    margin: "0 0 0 auto"
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      user_id: null,
      user_name: null,
      user_image: null,
    }
  }

  componentDidMount() {
    const user_id = cookie.load("user_id")
    if (user_id) {
      this.setState({ user_id: user_id })
      this.updateUser(user_id)
    }
  }

  updateUser = (user_id) => {
    fetch(config.backend_url + "users/" + user_id + "/name").then(
      (response) => {
        response.json().then((json) => {
          this.setState({ user_name: json.name, user_image: json.image_url, loading: false });
        });
      }
    );
  }


  render() {

    const { classes } = this.props;

    const handleDrawerToggle = () => {
      this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    const closeDrawer = () => {
      this.setState({ mobileOpen: false });
    };
    const logout = () => {
      this.setState({ user_id: null, user_name: null, user_image: null })
      cookie.remove('user_id', { path: '/' })
      console.log("logged out")
    }
    const handleLogin = (user_id) => {
      window.console.log(user_id)
      cookie.save('user_id', user_id, { path: '/', maxAge: 60*60*24*21 /* 21 days */ });
      this.setState({ user_id: user_id });
    };

    const handleUserUpdate = (user_id) => {
      window.console.log(user_id)
      this.updateUser(user_id)
    };

    const drawer = (
      <div>
        <div className={classes.toolbar} />
        <Divider />
        <List>
          <ListItem button component={Link} to="/" onClick={closeDrawer} >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText>ホーム</ListItemText>
          </ListItem>
          <ListItem button component={Link} to="/contests" onClick={closeDrawer}>
            <ListItemIcon>
              <SupervisorAccountIcon />
            </ListItemIcon>
            <ListItemText>コンテスト</ListItemText>
          </ListItem>
          <ListItem button component={Link} to="/ranking" onClick={closeDrawer}>
            <ListItemIcon>
              <EqualizerIcon />
            </ListItemIcon>
            <ListItemText>ランキング</ListItemText>
          </ListItem>
          {this.state.user_id ?
            <ListItem button component={Link} to={"/mypage"} onClick={closeDrawer} >
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText>マイページ</ListItemText>
            </ListItem>
            : ""}
          {this.state.user_id ?
            <ListItem button component={Link} to={"/draft"} onClick={closeDrawer} >
              <ListItemIcon>
                <EditIcon />
              </ListItemIcon>
              <ListItemText>作問</ListItemText>
            </ListItem>
            : ""}
          {this.state.user_id ?
            <ListItem button onClick={() => { logout() && closeDrawer() }} >
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText>ログアウト</ListItemText>
            </ListItem>
            :
            <ListItem button component={Link} to="/login" onClick={closeDrawer}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText>ログイン</ListItemText>
            </ListItem>
          }
        </List>
      </div>
    );

    return (
      <div className={classes.root} >
        <Router>
          <CssBaseline />
          <AppBar
            position="fixed"
            className={classes.appBar}
            style={{ backgroundColor: "#FFFFFF" }}
          >
            <Toolbar>
              <IconButton
                color="default"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
              <Link to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/nazocon.png`}
                  height="35"
                  width="200"
                  alt="logo"
                />
              </Link>
              {/* <Link to={"users/" + this.state.user_id > { this.state.user_id } </Link> */}
              <div className={classes.userIcon}>{(this.state.user_id && this.state.user_name) ? <Link to={"/mypage"}> <img width="30px" height="30px" src={this.state.user_image}/> </Link> : <Link to="/login">ログイン</Link>}</div>
            </Toolbar>
          </AppBar>
          <nav className={classes.drawer} aria-label="mailbox folders">
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Hidden smUp implementation="css">
              <Drawer
                // container={container}
                variant="temporary"
                open={this.state.mobileOpen}
                onClose={handleDrawerToggle}
                classes={{
                  paper: classes.drawerPaper,
                }}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
              <Drawer
                classes={{
                  paper: classes.drawerPaper,
                }}
                variant="permanent"
                open
              >
                {drawer}
              </Drawer>
            </Hidden>
          </nav>
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <Switch>
              <Route path="/contests/:contest_id" render={(props) => <ContestView {...props} user_id={this.state.user_id} />} />
              <Route path="/contests" component={ContestListView} />
              <Route path="/users/:name" render={(props) => <UserView {...props} user_id={this.state.user_id} user_name={this.state.user_name}/>} />
              <Route path="/mypage" render={(props) => <MyPageView {...props} handleUserUpdate={handleUserUpdate} user_id={this.state.user_id} user_name={this.state.user_name}/>} />
              <Route path="/ranking" component={RankingView} />
              <Route path="/draft" render={(props) => <DraftView {...props} user_id={this.state.user_id} user_name={this.state.user_name}/>}/>
              <Route path="/login/:user_id" render={(props) => <LoginView {...props} handleLogin={handleLogin} />} />
              <Route path="/login" component={LoginView} />
              <Route exact path="/" component={HomeView} />
              <Route render={() => <Redirect to="/" />} />
            </Switch>
            <div></div>
          </main>
        </Router>
      </div >
    );
  }
}

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,

};

export default withStyles(styles)(App);
